<script>
    import {Input, Label} from "flowbite-svelte";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import {EnvelopeSolid, PhoneSolid} from "flowbite-svelte-icons";
    import AddressDisplay from "$lib/components/AddressDisplay.svelte";

    export let employee;
    export let editing = false;

    let countryOptions = [];
</script>

<EmployeeWidget headline="Kontakt">
    <svelte:fragment slot="left">
        <Label>
            <div class="flex gap-2 items-center">
                <PhoneSolid slot="left" class="w-4 h-4 text-primary-400" />
                {#if editing}
                    <Input
                            bind:value={employee.mobile}
                            id="phone"
                            name="phone"
                            class="py-1" />
                {:else}
                    {#if employee.mobile}
                        <div class="py-1">
                            {employee.mobile}
                        </div>
                    {:else}
                                                    <span class="py-1 text-gray-400">
                                                        N/A
                                                    </span>
                    {/if}
                {/if}
            </div>
        </Label>

        <Label>
            <div class="flex gap-2 items-center">
                <EnvelopeSolid class="w-4 h-4 text-primary-400" />
                {#if editing}
                    <Input
                            bind:value={employee.email}
                            id="email"
                            name="email"
                            class="py-1" />
                {:else}
                    {#if employee.email}
                        <div class="py-1">
                            {employee.email}
                        </div>
                    {:else}
                                                    <span class="py-1 text-gray-400">
                                                        N/A
                                                    </span>
                    {/if}
                {/if}
            </div>
        </Label>

        <div class="my-1 h-[1px] bg-gray-200"></div>
        <div class="flex gap-2 items-center">
<!--            <Icon name="home-solid" slot="left" class="w-4 h-4 text-primary-400" />-->
            {#if editing}
                <div class="grid grid-cols-4 justify-between items-center w-full gap-x-6 gap-y-1">
                    <Label for="street" class="flex justify-end items-center">
                        Straße
                    </Label>
                    <Input
                            bind:value={employee.address.street}
                            id="street"
                            name="street"
                            class="col-span-3 py-1" />

                    <Label for="postalCode" class="flex justify-end items-center">
                        PLZ
                    </Label>
                    <Input
                            bind:value={employee.address.zip}
                            id="postalCode"
                            name="postalCode"
                            class="col-span-3 py-1" />

                    <Label for="city" class="flex justify-end items-center">
                        Ort
                    </Label>
                    <Input
                            bind:value={employee.address.place}
                            id="city"
                            name="city"
                            class="col-span-3 py-1" />

                    <Label for="country" class="flex justify-end items-center">
                        Land
                    </Label>
                    <div class="col-span-3">
                        <Typeahead
                                bind:value={employee.address.country}
                                data={countryOptions}
                                inputClass="py-1" />
                    </div>
                </div>
            {:else}

                {#if employee.address}
                    <AddressDisplay withIcon showMap address={employee.address} />
                {:else}
                    <span class="py-1 text-gray-400">
                        N/A
                    </span>
                {/if}
            {/if}
        </div>
    </svelte:fragment>
</EmployeeWidget>